<template>
  <div>
    <vg-heading>申请人员</vg-heading>
    <transition-group tag="div">
      <dp-application-applicant-form
          v-for="(form, index) in value"
          :ref="ref => formRefs[index] = ref"
          :key="form.id"
          v-model="form.fields"
          @insert="insert(index)"
          @remove="remove(index)"
          :allow-insert="allowInsert"
          :allow-remove="allowRemove"
      />
    </transition-group>
  </div>
</template>

<script>
import DpApplicationApplicantForm
  from "@/views/DigitalPassApplications/DigitalPassApplicationForm/DpApplicationApplicantForm.vue";
import idGenerate from "@/libraries/id-generate";
import VgHeading from "@/components/Html/VgHeading.vue";
import {Dialog} from "vant";
import useDpApplicationFormStore from "@/store/dp-application-form-store";

export default {
  name: "DpApplicationApplicantFormList",
  components: {VgHeading, DpApplicationApplicantForm},
  props: {
    value: {
      type: Array,
      default() {
        return []
      },
    },
    templateFields: {
      type: Array,
      default() {
        return []
      },
    },
    maxLength: {
      type: Number,
      default: 10
    },
  },
  data() {
    return {
      formRefs: []
    }
  },
  computed: {
    allowRemove() {
      return this.value.length > 1
    },
    allowInsert() {
      return this.value.length < this.maxLength
    }
  },
  watch: {
    value(newValue) {
      if (newValue.length <= 0) {
        this.insert(0)
      }
    },
  },
  methods: {
    input(value) {
      this.$emit('input', value)
      useDpApplicationFormStore().cache()
    },
    // reset() {
    //   this.input([{
    //     id: idGenerate(),
    //     fields: this.fields.map(field => ({...field}))
    //   }])
    // },
    insert(index) {
      this.input([
        ...this.value.filter((item, i) => i <= index),
        {
          id: idGenerate(),
          fields: this.templateFields.map(field => ({...field}))
        },
        ...this.value.filter((item, i) => i > index)
      ])
      if (this.value.length > 1) {
        this.$nextTick(() => {
          this.formRefs[index + 1].$el.scrollIntoView({
            behavior: "smooth",  // 平滑过渡
            block: 'center', //居中
          })
        })
      }
    },
    remove(index) {
      Dialog.confirm({
        message: '提示：是否确认删除？'
      }).then(() => {
        this.input(this.value.filter((item, i) => i !== index))
      })
    },
    validate() {
      return this.formRefs.flatMap(form => form?.validate())
    }
  }
}
</script>

<style scoped>
.v-enter-active,
.v-enter-active.dp-application-applicant-form >>> .form,
.v-leave-active,
.v-leave-active.dp-application-applicant-form >>> .form {
  transition: all 0.5s ease;
}

.v-enter,
.v-enter.dp-application-applicant-form >>> .form,
.v-leave-to,
.v-leave-to.dp-application-applicant-form >>> .form {
  opacity: 0;
  transform: translateX(-20px);

}

.v-leave-to,
.v-leave-to.dp-application-applicant-form >>> .form {
  max-height: 0;
}

.v-enter-to,
.v-enter-to.dp-application-applicant-form >>> .form,
.v-leave,
.v-leave.dp-application-applicant-form >>> .form {
  max-height: 100vh;
}

</style>
